var map = {
	"./alice_characters.jpg": 9547,
	"./alice_location1.jpg": 6406,
	"./alice_location2.jpg": 832,
	"./alice_location3.jpg": 8447,
	"./alice_location4.jpg": 3334,
	"./alice_location5.jpg": 728,
	"./alice_location6.jpg": 1220,
	"./alice_location7.jpg": 6217,
	"./alice_location8.jpg": 9893,
	"./char10_slots.jpg": 6773,
	"./char11_slots.jpg": 6074,
	"./char12_slots.jpg": 6671,
	"./char15_slots.jpg": 1926,
	"./char16_slots.jpg": 1162,
	"./char1_royal.jpg": 4872,
	"./char1_slots.jpg": 6250,
	"./char2_royal.jpg": 8434,
	"./char2_slots.jpg": 3480,
	"./char3_royal_slots.jpg": 1819,
	"./char3_slots.jpg": 7537,
	"./char4_royal_slots.jpg": 595,
	"./char4_slots.jpg": 9284,
	"./char5_slots.jpg": 8188,
	"./char6_slots.jpg": 6930,
	"./char7_slots.jpg": 8063,
	"./char8_slots.jpg": 7658,
	"./char_13_slots.jpg": 389,
	"./char_14_slots.jpg": 1247,
	"./corgi_big_1.png": 4107,
	"./event_halloween1.jpg": 4351,
	"./event_ny.jpg": 3627,
	"./event_ny2.jpg": 9006,
	"./event_pick.jpg": 4507,
	"./icon_777_2021.png": 2239,
	"./icon_777_2022.png": 9578,
	"./icon_Chameleon_sunset.png": 1820,
	"./icon_buffalo.png": 4293,
	"./icon_cash.png": 9954,
	"./icon_cash_closechest.png": 142,
	"./icon_chameleon2.png": 3351,
	"./icon_cherry.png": 8711,
	"./icon_chesh_3inrow.png": 1254,
	"./icon_chesh_hat.png": 8765,
	"./icon_chesh_sunglasse.png": 5817,
	"./icon_cheshirecat.png": 7933,
	"./icon_chicagogirl.png": 7378,
	"./icon_chicken.png": 1961,
	"./icon_closechest_newcoins.png": 8596,
	"./icon_clover.png": 4230,
	"./icon_coinbg23_512x512.png": 1759,
	"./icon_cryptocoin_dog.png": 6511,
	"./icon_doggy_pinapple.png": 5446,
	"./icon_doggymatch.png": 1906,
	"./icon_dynamite.png": 8996,
	"./icon_fish.png": 9431,
	"./icon_fox.png": 3262,
	"./icon_kitty3.png": 665,
	"./icon_kitty_crown.png": 3233,
	"./icon_leprhat.png": 2991,
	"./icon_octopusfield.png": 97,
	"./icon_pearl.png": 1491,
	"./icon_pepper_2021.png": 1121,
	"./icon_pepper_2022.png": 1516,
	"./icon_pot.png": 6166,
	"./icon_pot_2022.png": 6537,
	"./items1_royal.jpg": 3011,
	"./items1_summer.jpg": 3717,
	"./items2_royal.jpg": 1520,
	"./items2_slots.jpg": 8902,
	"./items2_summer.jpg": 3514,
	"./items3_slots.jpg": 9646,
	"./items3_summer.jpg": 1575,
	"./items4_slots.jpg": 9477,
	"./items4_summer.jpg": 2438,
	"./items5_slots.jpg": 7904,
	"./items6_slots.jpg": 3840,
	"./items7_slots.jpg": 3484,
	"./items_alice.jpg": 6691,
	"./items_slots.jpg": 8285,
	"./logo.png": 4427,
	"./mob_alice_chars1.jpg": 6268,
	"./mob_alice_chars2.jpg": 5569,
	"./mob_alice_chars3.jpg": 4867,
	"./mob_animals_slots1.jpg": 4456,
	"./mob_animals_slots2.jpg": 652,
	"./mob_animals_slots3.jpg": 1078,
	"./mob_summer_friend1.jpg": 7258,
	"./mob_summer_friend12.jpg": 3955,
	"./mob_summer_friend3.jpg": 2739,
	"./panda2.png": 9504,
	"./royal_location1.jpg": 5271,
	"./royal_location2.jpg": 3673,
	"./royal_location3.jpg": 4277,
	"./royal_location4.jpg": 8381,
	"./royal_location5.jpg": 2227,
	"./royal_location6.jpg": 1686,
	"./slot_aztec.jpg": 1486,
	"./slot_buffalo.jpg": 8080,
	"./slot_cabaret.jpg": 9080,
	"./slot_characters1.jpg": 5401,
	"./slot_classic.jpg": 2133,
	"./slot_doctor.jpg": 3462,
	"./slot_fireman.jpg": 9471,
	"./slot_japan.jpg": 7491,
	"./slot_japan2.jpg": 5348,
	"./slot_kong.jpg": 1061,
	"./slot_location1.jpg": 7842,
	"./slot_location2.jpg": 4501,
	"./slot_location3.jpg": 375,
	"./slot_location4.jpg": 7758,
	"./slot_location5.jpg": 9439,
	"./slot_location6.jpg": 4954,
	"./slot_location7.jpg": 1079,
	"./slot_ninja.jpg": 5410,
	"./slot_oz.jpg": 2115,
	"./slot_pinup.jpg": 2129,
	"./slot_poker.jpg": 2430,
	"./slot_robbery.jpg": 5916,
	"./slot_sherlock.jpg": 9799,
	"./slot_sparta.jpg": 7251,
	"./slot_tennis.jpg": 9883,
	"./slot_troy1.jpg": 106,
	"./slot_troy2.jpg": 6383,
	"./slot_usa.jpg": 4804,
	"./summer_characters.jpg": 2740,
	"./summer_locations1.jpg": 7092,
	"./summer_locations2.jpg": 9175,
	"./summer_locations3.jpg": 4758,
	"./summer_locations4.jpg": 4025,
	"./summer_locations5.jpg": 6878,
	"./ui_ns_1.jpg": 9177,
	"./ui_ns_1.png": 6385,
	"./ui_ns_2.jpg": 2250,
	"./ui_ns_2.png": 3737,
	"./ui_ns_3.jpg": 4565,
	"./ui_ns_3.png": 8682,
	"./ui_ns_4.jpg": 3322,
	"./ui_ns_4.png": 2670,
	"./ui_ns_5.jpg": 1761,
	"./ui_ns_5.png": 9389,
	"./ui_rs_1.jpg": 9531,
	"./ui_rs_1.png": 6764,
	"./ui_rs_2.jpg": 3451,
	"./ui_rs_2.png": 1652,
	"./ui_rs_3.jpg": 48,
	"./ui_rs_3.png": 1356,
	"./ui_sf_1.jpg": 5748,
	"./ui_sf_1.png": 3874,
	"./ui_sf_2.jpg": 6355,
	"./ui_sf_2.png": 5991,
	"./ui_sf_3.jpg": 5921,
	"./ui_sf_3.png": 5987,
	"./ui_sf_4.jpg": 527,
	"./ui_sf_4.png": 5090,
	"./ui_sf_5.jpg": 4091,
	"./ui_sf_5.png": 5126,
	"./ui_sf_6.jpg": 4327,
	"./ui_sf_6.png": 4369
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 990;